exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#monitor_option[data-v-889c170a] .v-select__selection {\n    font-size: 14px;\n    height: 20px;\n}\n#monitor_option[data-v-889c170a] .v-select__selections input{\n    display: none;\n}\n", ""]);

